$('body').on('click', '.rating-table__stage, .rating-table__total', function() {
    var stageNumber = $(this).data('stage-number'),
        classNumber = $('.rating-classes-input').data('class-number'),
        classLetter = $('.rating-classes-input').data('class-letter'),
        entityType = $('.rating-entity-input').data('id'),
        entityId = $('.rating-entity-input').data('type'),
        additionalData;

    $('.rating-wrap').parents('.loading').addClass('visible');

    if (classNumber !== '') {
        classNumber = '&class_number=' + classNumber;
    }
    else {
        classNumber = '';
    }
    if (classLetter !== '') {
        classLetter = '&class_letter=' + classLetter;
    }
    else {
        classLetter = '';
    }
    if (entityType !== '') {
        entityType = '&entity_type=' + entityType;
    }
    else {
        entityType = '';
    }
    if (entityId !== '') {
        entityId = '&entity_id=' + entityId;
    }
    else {
        entityId = '';
    }

    additionalData = classNumber + classLetter + entityType + entityId;
    getRating(stageNumber, additionalData);
})

$('body').on('click', '.rating-classes-select .select__option', function() {
    var stageNumber = $('.rating-table__selected-stage').data('stage-number'),
        classNumber = $(this).data('class-number'),
        classLetter = $(this).data('class-letter'),
        entityType = $('.rating-entity-input').data('id'),
        entityId = $('.rating-entity-input').data('type'),
        additionalData;


        $('.rating-wrap').parents('.loading').addClass('visible');

        if (classNumber !== '') {
            classNumber = '&class_number=' + classNumber;
        }
        else {
            classNumber = '';
        }
        if (classLetter !== '') {
            classLetter = '&class_letter=' + classLetter;
        }
        else {
            classLetter = '';
        }
        if (entityType !== '') {
            entityType = '&entity_type=' + entityType;
        }
        else {
            entityType = '';
        }
        if (entityId !== '') {
            entityId = '&entity_id=' + entityId;
        }
        else {
            entityId = '';
        }

    additionalData = classNumber + classLetter + entityType + entityId;
    getRating(stageNumber, additionalData);
})

$('body').on('click', '.rating-entity-select .select__option', function() {
    var stageNumber = $('.rating-table__selected-stage').data('stage-number'),
        classNumber = $('.rating-classes-input').data('class-number'),
        classLetter = $('.rating-classes-input').data('class-letter'),
        entityType = $(this).data('type'),
        entityId = $(this).data('id'),
        additionalData;

    $('.rating-wrap').parents('.loading').addClass('visible');

    if (classNumber !== '') {
        classNumber = '&class_number=' + classNumber;
    }
    else {
        classNumber = '';
    }
    if (classLetter !== '') {
        classLetter = '&class_letter=' + classLetter;
    }
    else {
        classLetter = '';
    }
    if (entityType !== '') {
        entityType = '&entity_type=' + entityType;
    }
    else {
        entityType = '';
    }
    if (entityId !== '') {
        entityId = '&entity_id=' + entityId;
    }
    else {
        entityId = '';
    }

    additionalData = classNumber + classLetter + entityType + entityId;
    getRating(stageNumber, additionalData);
})

$('body').on('click', '.js-stage-tab-btn', function() {
    var stageBtnIndex = $(this).index(),
        resultCurrentStage;

    $('.result-wrap').parents('.loading').addClass('visible');

    resultCurrentStage = stageBtnIndex + 1;
    getResult(resultCurrentStage, '');
})

$('body').on('click', '.rating__person', function() {
    var userId = $(this).data('user-id');

    $('.rating__person').removeClass('rating__person_selected-user rating__person_prev-selected-user');
    $(this).addClass('rating__person_selected-user');
    $(this).prev().addClass('rating__person_prev-selected-user');
    getUserPopup(userId);
})
